import { getBrowserMediaQueryWidth } from 'shared/lib/utils';

type ScreenWidthListener = (width: number) => void;

/**
 * Singleton module that manages the screen width state and notifies subscribed
 * components when the screen width changes.
 */
const ScreenWidthManager = (() => {
  let screenWidth = getBrowserMediaQueryWidth();

  const listeners = new Set<ScreenWidthListener>();

  const handleResize = () => {
    screenWidth = getBrowserMediaQueryWidth();
    notifyListeners();
  };

  const subscribe = (listener: ScreenWidthListener) => {
    listeners.add(listener);
  };

  const unsubscribe = (listener: ScreenWidthListener) => {
    listeners.delete(listener);
  };

  const notifyListeners = () => {
    for (const listener of listeners) {
      listener(screenWidth);
    }
  };

  window.addEventListener('resize', handleResize);

  return {
    screenWidth,
    subscribe,
    unsubscribe,
  };
})();

export default ScreenWidthManager;
